import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";

import Grid from "@material-ui/core/Grid";

import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

import emailjs from "emailjs-com";
import firebase from "firebase";
import { useHistory } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "1400px",
    margin: "0 auto",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function SingUp() {
  const history = useHistory();
  function handlePrijava() {
    history.push("/prijave");
  }

  const classes = useStyles();

  const [spinner,setSpinner] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    setSpinner(true)
    const gost = {
      name: e.target.ime.value,
      surname: e.target.prezime.value,
      email: e.target.email.value,
      submitDate: new Date().toLocaleDateString(),
      payed: false,
      payDate: false,
    };
    console.log("Hey")

    let newPostKey =
      gost.name +
      "_" +
      gost.surname +
      "_" +
      Math.floor(Math.random() * 1000) +
      1 +
      "_" +
      Math.floor(Math.random() * 1000) +
      1;

    var updates = {};
    updates["Gosti/prijave/" + newPostKey] = gost;

    emailjs
      .send(
        "serviceProba",
        "prijavaGost",
        {
          email: gost.email,
        },
        "user_hU4wKMTGiLWs2jfLyPHR4"
      )
      .then((res) => {
        // TODO SPINNER AND DISABLE PAGE
        
        firebase
        .database()
        .ref("Gosti/prijave/" + newPostKey)
        .set(gost)
        .then(() => {
          e.target.reset();
          setSpinner(false)
          window.location.reload(false);
        });
        
      })
      .catch((err) => {
        alert("Pogreška pri slanju Pokušajte kasnije");
        console.log(err);
      });


  };

  return (
    <Container
      component="main"
      id="prijavise"
      style={{
        maxWidth: "100%",
      }}
    >
      <CssBaseline />
      <div
        className={classes.paper}
        style={{ marginBottom: "80px", backgroundColor: "#F6F7FD" }}
      >
        <Grid container direction="column" alignItems="center">
          <Typography
            variant="h4"
            style={{ marginTop: "20px", color: "#0E1B4D", fontWeight: "bold" }}
          >
            PRIJAVI SE
          </Typography>
          <Typography
            variant="h6"
            color="textSecondary"
            style={{ textAlign: "center" }}
          >
            Ispunite formu kako biste se prijavili na konferenciju.
          </Typography>
        </Grid>

        {/* TODO RED LINE */}
        {
          spinner? <CircularProgress/> :
        
        <form onSubmit={handleSubmit} id="submit_form">
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="ime"
            label="Ime"
            type="text"
            id="firstName"
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="prezime"
            label="Prezime"
            type="text"
            id="lastName"
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
          />

          <Grid container>
            <Button
              type="submit"
              // TODO CHANGE TYPE INTO SUBMIT TO MAKE EMAILS SEND
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              style={{
                backgroundColor: "#1F94C2",
                width: "50%",
                borderRadius: "30px",
              }}
            >
              GOST
            </Button>
            <Button
              type="button"
              fullWidth
              variant="contained"
              color="secondary"
              onClick={handlePrijava}
              className={classes.submit}
              style={{
                backgroundColor: "#45B283",
                width: "50%",
                borderRadius: "30px",
              }}
            >
              Predavač
            </Button>
          </Grid>
        </form>
}
     </div>
    </Container>
  );
}

export default SingUp;
